import type { FC } from "react"
import React from "react"
import type { DotProps } from "recharts"

const DelegatesChartDot: FC<DotProps & { color: string }> = ({ color }) => (
  <svg
    height={15}
    preserveAspectRatio="xMidYMin slice"
    style={{ display: "inline" }}
    viewBox="0 -10 40 40"
    width={15}
  >
    <circle cx="20" cy="20" fill={color} r="10" />
  </svg>
)

export default DelegatesChartDot
